import {
  Drawer,
  IconButton,
} from "@mui/material";
import React, { useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

const NewMobile = ({ openState, event }) => {
  const [open, setOpen] = openState
  const paperRef = useRef();

  if (!event) {
    return <></>
  }

  return (
    <Drawer
      anchor="top"
      open={open}
      ref={paperRef}
      PaperProps={{
        sx: { width: "100%", m: "auto", height: "100%" }
      }}
    >
      <IconButton
        sx={{
          position: "absolute",
          top: "0",
          marginLeft: "16px",
          marginTop: "8px",
          backgroundColor: "grey"
        }}
        onClick={() => setOpen(!open)}
      >
        <CloseIcon />
      </IconButton>
      <img src={event.event_image} />
      <div
        style={{
          fontSize: "25px",
          fontFamily: "indie flower",
          margin: "3%"
        }}
      >
        <h2 style={{ fontSize: "30px" }}>{event.title}</h2>
        {event.announcement}
      </div>

      <div
        style={{
          color: "black",
          fontSize: "20px",
          margin: "3%",
          padding: "3%",
          textAlign: "center",
          backgroundColor: "rgba(255, 238, 195)",
          borderRadius: "5px",
          fontFamily: "indie flower",
          fontWeight: "bold"

        }}
        onClick={(e) => {
          setOpen(!open)
        }}
      >
        SULJE
      </div>
    </Drawer>
  );
};

export default NewMobile;